require('ca-assets/stylesheets/legacy/reset.scss');
require('ca-assets/stylesheets/legacy/common.scss');
require('ca-assets/stylesheets/legacy/shared/_navicons.scss');
require('select2/select2.css');
require('ca-assets/stylesheets/legacy/_select2-overrides.scss');
require('ca-assets/stylesheets/legacy/modal.scss');
